import {
  BuilderContext,
  BuilderOutput,
  createBuilder
} from '@angular-devkit/architect';

import * as engine from '../engine/engine';
import deploy from './actions';
import { Schema } from './schema';
import { BuildTarget } from '../interfaces';

/**
 * The core builder handler function.
 * Exported separately for testing purposes.
 */
export async function executeDeploy(
  options: Schema,
  context: BuilderContext
): Promise<BuilderOutput> {
  // browserTarget is not supported - use buildTarget instead
  if ((options as Record<string, unknown>).browserTarget) {
    context.logger.error('❌ The "browserTarget" option is not supported.');
    context.logger.error('   Use "buildTarget" instead.');
    return { success: false };
  }

  if (!context.target) {
    throw new Error('Cannot deploy the application without a target');
  }

  const staticBuildTarget: BuildTarget = {
    name:
      options.buildTarget || `${context.target.project}:build:production`
  };

  let prerenderBuildTarget: BuildTarget | undefined;
  if (options.prerenderTarget) {
    prerenderBuildTarget = {
      name: options.prerenderTarget
    };
  }

  // serverBuildTarget is not supported and is completely ignored
  // let serverBuildTarget: BuildTarget | undefined;
  // if (options.ssr) {
  //   serverBuildTarget = {
  //     name: options.serverTarget || options.universalBuildTarget || `${context.target.project}:server:production`
  //   };
  // }

  const finalBuildTarget = prerenderBuildTarget
    ? prerenderBuildTarget
    : staticBuildTarget;

  try {
    await deploy(engine, context, finalBuildTarget, options);
  } catch (e) {
    context.logger.error('❌ An error occurred when trying to deploy:');
    const message = e instanceof Error ? e.message : String(e);
    context.logger.error(message);
    return { success: false };
  }

  return { success: true };
}

// Call the createBuilder() function to create a builder. This mirrors
// createJobHandler() but add typings specific to Architect Builders.
//
// if something breaks here, see how angularfire has fixed it:
// https://github.com/angular/angularfire/blob/master/src/schematics/deploy/builder.ts
export default createBuilder(executeDeploy);
